export type CategoryApprovalStatus = 'Pending Review' | 'Approved' | 'Manual';

export const normalizeCategoryApprovalStatus = (value?: string | null): CategoryApprovalStatus => {
  const normalized = (value || '').trim().toLowerCase();

  if (normalized === 'approved') {
    return 'Approved';
  }

  if (normalized === 'manual') {
    return 'Manual';
  }

  return 'Pending Review';
};

export const getApprovalStatusLabel = (value?: string | null): CategoryApprovalStatus => normalizeCategoryApprovalStatus(value);

export const getApprovalStatusBadgeTone = (value?: string | null): 'default' | 'success' | 'danger' => {
  const status = normalizeCategoryApprovalStatus(value);
  if (status === 'Approved') {
    return 'success';
  }
  if (status === 'Pending Review') {
    return 'danger';
  }
  return 'default';
};
